<template>
  <div class="basic_wrap">


    <img src="../images/share/recharge_bg.png" class="myteam-bg">

    <div class="aitwrap">
      <div class="aitem" v-for="(item, index) in activeItem" :key="index" @click="$router.push('/article/' + item.id)">
        <div class="aname">{{ item.title }}</div>
        <img :src="item.image" style="width:100%;" alt="">
        <!-- <img src="../images/active/01.png" style="width:100%;" alt=""> -->
        <img src="../images/active/bt.png" class="btimg" alt="">
      </div>
    </div>


    <img src="../images/item/telegram.png" @click="joinTheGroup()" class="telegram" alt="" width="100">

    <div class="open-box" v-show="is_open" @click="is_open = false;">
      <div class="box-wrap">
        <img src="../images/item/box.gif" class="box">
        <p class="bonus">R${{ bonus }}</p>
      </div>

    </div>
    <ft></ft>
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import ft from '../../components/ft.vue'
import Vue from 'vue';
import { Tab, Tabs, Progress, Empty, Dialog, Field } from 'vant';
import ItemList from "@/components/itemList";

Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
  name: "item",
  data() {
    return {
      is_open: false,
      bonus: 0.00,
      activeItem: [],
      group_service: null,
    }
  },
  components: {
    ItemList, ft
  },
  created() {
    this.$parent.footer('item');
    this.active_list();
  },
  mounted() {
    Fetch('/user/getUserInfoApi2').then((r) => {
      this.service = r.data.service;
      this.group_service = r.data.group_service;
    });
  },
  methods: {
    showBoom() {

      var dayOfWeek = new Date().getDay();
      var isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0); // 6 = Saturday, 0 = Sunday
      console.log(isWeekend);
      if (!isWeekend) {
        return this.$toast({
          // type:'fail',
          icon: require("../images/common/laugh.png"),
          background: "#07c160",
          message: "Explore a emoção dos nossos jogos online! Potencialize sua experiência com recargas e desfrute de bônus especiais. Lembre-se, aos fins de semana, há um bônus gratuito esperando por você. Venha jogar e ganhar conosco!",
          duration: 10000,
        });
      }

      Fetch('/reward/open_reward', {}, false, true).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.bonus = res.data.amount;
          this.is_open = true;
        } else {
          this.$toast({
            background: "#07c160",
            message: res.msg,
            duration: 5000,
          });
        }
      });

    },
    joinTheGroup() {
      window.location.href = this.group_service;
    },

    active_list() {
      Fetch('/user/active_list', {}, false, true).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.activeItem = res.data;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.btimg{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.aitwrap{
  margin-top: 1.5rem;
}
.myteam-bg {
  width: 100%;
  height: 3.0rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.details {
  text-align: center;
  margin-top: 10px;
  color: #82a504;
  font-size: 16px;
  font-weight: 600;

}

.box-wrap {
  position: relative;
}

.bonus {
  text-align: center;
  font-size: 0.8rem;
  color: gold;
  position: absolute;
  bottom: 10px;
  width: 100%;
  font-weight: 700;
  // left: 41%;
}

.box {
  width: 60%;
  height: auto;
  display: block;
  margin: 20% auto 18px;
}

.open-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  //background-color: rgba(0, 0, 0, 0.5);
  background: #0e4114;
  z-index: 3;
}

.ades {
  margin-top: 10px;
  font-size: 0.37rem;
  color: rgba(255, 255, 255, 0.737);
  line-height: 20px;
  text-indent: 10px;
}

.aname {
  font-size: 0.33rem;
  line-height: 18px;
  color: #84A559;
}

.aitem {
  width: 92%;
  margin: 0 auto 15px;
  border-radius: 10px;
  padding: 8px 15px;
  border: 1px solid #84A559;
  position: relative;
  padding-bottom: 0.7rem;
}


.basic_wrap {
  background: url("../images/vip/sbg.png") repeat;
  min-height: 100%;
  padding-top: 15px;

}

.daily-gift {
  position: absolute;
  width: 2rem;
  bottom: 55px;
  left: 10px;
  z-index: 2;
  animation: my-btn 0.9s ease-in infinite;
}

.telegram {
  position: absolute;
  width: 1.3rem;
  bottom: 66px;
  right: 20px;
  z-index: 2;
  // background: white;
  // border-radius: 80%;
  // overflow: hidden;
  // animation: my-btn 0.9s ease-in infinite;

}


@keyframes my-btn {
  0% {
    transform: translateX(0rpx);
    transform: scale(.8);
  }

  50% {
    transform: translateX(20rpx);
    transform: scale(1);
  }

  100% {
    transform: translateX(0rpx);
    transform: scale(.8);
  }
}
</style>
